// extracted by mini-css-extract-plugin
export default {"button":"ThemeToggle_button__ZRe90","icon":"ThemeToggle_icon__3FOON","fullWidth":"ThemeToggle_fullWidth__FduB5"};